<app-form-field-wrapper [label]="label" [name]="name" [colSize]="colSize">
  <p-dropdown
    id="defaultColorSet"
    [filter]="true"
    [showClear]="true"
    [(ngModel)]="selection"
    (ngModelChange)="onChange($event)"
    (onChange)="onDropdownChange($event.value)"
    [filterFields]="['name']"
    [options]="colorsets"
    [placeholder]="placeholder"
    optionLabel="name"
    optionValue="_id"
    panelStyleClass="colorset-dropdown-panel">
    <ng-template pTemplate="header">
      @if (enableNewOption) {
        <div class="p-2 border-bottom-1 surface-border">
          <p-button
            styleClass="w-auto"
            [text]="true"
            [rounded]="true"
            (onClick)="openColorsetForm()"
            icon="fas fa-plus"
            label="hinzufügen"></p-button>
        </div>
      }
    </ng-template>
    <ng-template pTemplate="selectedItem" let-selectedOption>
      <div *ngIf="selectedOption" class="colorset-selected">
        <span class="colorset-name">{{ selectedOption.name }}</span>
        <span class="colorset-colors">
          <i
            class="fas fa-circle"
            [style.color]="color"
            *ngFor="let color of selectedOption.colors"></i>
        </span>
      </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="colorset-option">
        <div class="flex align-items-center gap-2 min-w-0">
          <i class="fas fa-palette"></i>
          <span class="colorset-name">{{ item.name }}</span>
        </div>
        <span class="colorset-colors">
          <i
            class="fas fa-circle"
            [style.color]="color"
            *ngFor="let color of item.colors"></i>
        </span>
      </div>
    </ng-template>
  </p-dropdown>
</app-form-field-wrapper>
